export const VerticalTypeToTranslationKeyMap: Record<string, string> = {
  TRANSFER: "1",
  MECHANICAL_INSPECTION: '2',
  VEHICLE_WASH: '3',
  REFUELING: '4',
  PRE_TECHNICAL_INSPECTION: '5',
  LONG_DISTANCE_TRANSFER: '6',
  TECHNICAL_INSPECTION: '7',
  VEHICLE_INSURANCE: '8',
  VEHICLE_DATA_COLLECTION: '9',
  ACCESSORY: '10',
  VALET: '11',
  TYRES: '12',
  FORMALITIES: '13',
  PARKING: '14',
  REPLACEMENT_VEHICLE: '15',
  TOW_TRUCK: '16',
  WHATEVER_YOU_WANT: '17',
  VEHICLE_STORAGE: '18',
  BATTERY: '19',
  INTERNAL_PICKUP: '900',
  INTERNAL_RETURN: '901',
  INTERNAL_TRANSFER: '902',
  UNKNOWN: '1000',
};

export enum VerticalType {
  Transfer = 1,
  MechanicalInspection = 2,
  VehicleWash = 3,
  Refueling = 4,
  PreTechnicalInspection = 5,
  LongDistanceTransfer = 6,
  TechnicalInspection = 7,
  VehicleInsurance = 8,
  VehicleDataCollection = 9,
  Accessory = 10,
  Valet = 11,
  Tyres = 12,
  Formalities = 13,
  Parking = 14,
  ReplacementVehicle = 15,
  TowTruck = 16,
  WhateverYouWant = 17,
  VehicleStorage = 18,
  Battery = 19,
  InternalPickup = 900,
  InternalReturn = 901,
  InternalTransfer = 902,
  Overdrafts = 1000,
}

export const DistanceVerticals: VerticalType[] = [
  VerticalType.Transfer,
  VerticalType.LongDistanceTransfer,
];
